module.exports = __webpack_public_path__ + "r-v3/img/arrowLineThickBottom.a78d350d.svg";